$(document).ready(function() {
    $(".js-m-close-click").unbind('click').bind('click', function() {
        var elem = $(this).data("close");
        $('#' + elem).velocity("slideUp", { duration: 250 });
    });
});